// extracted by mini-css-extract-plugin
module.exports = {"section":"rabattkoder_section__mv83y"};